import React from "react";
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Buy from "./pages/Buy";
import Sell from "./pages/Sell";
import Rent from "./pages/Rent";

import Contact from "./pages/Contact";
import Login from "./pages/Login";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AddProperty from "./pages/AddProperty";
import EditProperty from "./pages/EditProperty";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import AdminSignup from "./pages/AdminSignup";
import AdminForgotPassword from "./pages/AdminForgotPassword";
import PropertyDetails from "./pages/PropertyDetails";
import AdminBuys from "./pages/AdminBuys";
import AdminSales from "./pages/AdminSales";
import AdminRents from "./pages/AdminRents";
import AdminMessages from "./pages/AdminMessages";
import AdminSettings from "./pages/AdminSettings";
import AdminProperties from "./pages/AdminProperties";

// Wrapper component for conditional Navbar/Footer
function Layout({ children }) {
  const location = useLocation();

  const hideLayout =
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/add") ||
    location.pathname.includes("/edit") ||
    location.pathname.startsWith("/property");

  return (
    <>
      {!hideLayout && <Navbar />}
      {children}
      {!hideLayout && <Footer />}
    </>
  );
}



function App() {
  return (
    <HashRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/buy" element={<Buy />} />
          <Route path="/sell" element={<Sell />} />
          <Route path="/rent" element={<Rent />} />
          
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/add" element={<AddProperty />} />
          <Route path="/edit/:id" element={<EditProperty />} /> 
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin/signup" element={<AdminSignup />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/property/:id" element={<PropertyDetails />} />
          <Route path="/admin/buys" element={<AdminBuys />} />
          <Route path="/admin/sales" element={<AdminSales />} />
          <Route path="/admin/rents" element={<AdminRents />} />
          <Route path="/admin/messages" element={<AdminMessages />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/properties" element={<AdminProperties />} />
        </Routes>
      </Layout>
    </HashRouter>
  );
}

export default App; 